var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showMe,
            expression: "showMe"
          }
        ],
        staticClass: "bg-white",
        attrs: { id: "panel-slider-container" }
      },
      [
        _c("div", { staticClass: "pagingInfo" }),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { id: "panel-detail" } },
          _vm._l(_vm.projects, function(project) {
            return _c("panel-detail-project", {
              key: project.project_id,
              attrs: { project: project }
            })
          })
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: { href: "javascript:void(0)", id: "panel-detail-close" },
            on: { click: _vm.closePanel }
          },
          [_vm._v("close")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!C:/Code/mappingnhn/web/app/themes/mapping/node_modules/vue-loader/lib?{}!./scripts/vue/PanelDetail.vue?vue&type=template&id=2cf8b7f1&
// module id = 88
// module chunks = 0